// extracted by mini-css-extract-plugin
module.exports = {"cookieInfo":"bt_bu","cookieInfoContainer":"bt_bv"};